import { TranslationService } from "../../../services/TranslationService";
import { AgentMonitorSummaryResponse } from "../../../services/AgentMonitorService";
import "./agentMonitor.css";

interface AgentMonitorMetricCardsProps {
  summary: AgentMonitorSummaryResponse | null;
  loading: boolean;
  error: boolean;
  onRefresh: () => void;
}

interface MetricCardProps {
  label: string;
  value: number | undefined;
  icon: string;
  valueColor: string;
  loading: boolean;
  error: boolean;
}

const MetricCard = ({
  label,
  value,
  icon,
  valueColor,
  loading,
  error
}: MetricCardProps) => {
  const { translate } = TranslationService;
  return (
    <div className="am-metric-card flex-fill" style={{ minWidth: 0 }}>
      <div className="am-metric-card-top">
        <span className="am-metric-label">{label}</span>
        <span className="am-metric-icon">
          <i className={icon}></i>
        </span>
      </div>
      {loading && <div className="am-metric-skeleton" />}
      {!loading && error && (
        <span className="text-danger small">
          {translate.ErrorLoadingData || "Error al cargar"}
        </span>
      )}
      {!loading && !error && (
        <span className="am-metric-value" style={{ color: valueColor }}>
          {value ?? 0}
        </span>
      )}
    </div>
  );
};

const AgentMonitorMetricCards = ({
  summary,
  loading,
  error,
  onRefresh
}: AgentMonitorMetricCardsProps) => {
  const { translate } = TranslationService;

  const cards = [
    {
      label: translate.AgentsAvailable || "Agentes disponibles",
      value: summary?.availableAgents,
      icon: "far fa-user-group",
      valueColor: "#16a34a"
    },
    {
      label: translate.ChatsWithoutAssignment || "Chats sin asignar",
      value: summary?.unassignedChats,
      icon: "far fa-comment",
      valueColor: "#1a56db"
    },
    {
      label: translate.TotalOpenChats || "Chats abiertos totales",
      value: summary?.totalOpenChats,
      icon: "far fa-comments",
      valueColor: "#1a56db"
    },
    {
      label: translate.FinishedToday || "Finalizadas hoy",
      value: summary?.chatsEnded,
      icon: "far fa-check",
      valueColor: "#111827"
    }
  ];

  return (
    <div className="d-flex gap-3 mb-4">
      {cards.map((card) => (
        <MetricCard
          key={card.label}
          label={card.label}
          value={card.value}
          icon={card.icon}
          valueColor={card.valueColor}
          loading={loading}
          error={error}
        />
      ))}
    </div>
  );
};

export default AgentMonitorMetricCards;
